// La fenêtre « Nouveau statut ».
//
// Sortie de `views/stories.js`, dont le bandeau et la visionneuse sont passés à
// React. Comme les autres fenêtres modales, elle reste en HTML : elle s'ouvre,
// se remplit, se ferme, et n'a pas d'état qui vive dans le temps.

import Store from "../store.js";
import { esc, toast, modale } from "../ui.js";
import { icone } from "../icones.js";
import { APP } from "../config.js";

const FONDS = APP.fondsStory;
const limiteVideo = () => (Store.mode === "local" ? APP.videoMaxMo.local : APP.videoMaxMo.firebase);

export function composerStory(ctx) {
  let fond = 0;
  let media = "";
  let typeMedia = "";

  const { el } = modale({
    titre: "Nouveau statut",
    corps: `
      <div class="story-edit" id="story-apercu" style="background:${FONDS[0]}">
        <textarea id="story-texte" rows="3" maxlength="240" placeholder="Écrivez quelque chose…"></textarea>
        <div class="story-edit__media" hidden></div>
      </div>
      <div class="story-fonds" id="story-fonds">
        ${FONDS.map((f, i) => `<button class="story-fond${i === 0 ? " est-actif" : ""}" data-fond="${i}" style="background:${f}" aria-label="Fond ${i + 1}"></button>`).join("")}
      </div>
      <div class="story-ajouts">
        <label class="btn btn--fantome btn--petit">${icone("photo", { taille: 18 })} Photo<input type="file" id="story-image" accept="image/*" hidden></label>
        <label class="btn btn--fantome btn--petit">${icone("video", { taille: 18 })} Vidéo<input type="file" id="story-video" accept="video/*" hidden></label>
        <span class="petit texte-doux" id="story-info"></span>
      </div>
      <p class="petit texte-doux">Votre statut disparaîtra automatiquement dans 24 h.</p>`,
    actions: [
      { label: "Annuler" },
      {
        label: "Publier le statut",
        classe: "btn--primaire",
        onClick: async (fond_, fermer) => {
          const texte = el.querySelector("#story-texte").value.trim();
          if (!texte && !media) return toast("Écrivez un texte ou ajoutez une photo", "erreur");
          fermer();
          try {
            await Store.stories.add({
              authorId: ctx.moi.uid,
              auteurNom: ctx.moi.nom,
              auteurPhoto: ctx.moi.photo || "",
              type: typeMedia || "texte",
              media,
              texte,
              fond,
            });
            toast("Statut publié 🎉");
          } catch (e) {
            toast(e.message || "Publication impossible", "erreur");
          }
        },
      },
    ],
  });

  const apercuEl = el.querySelector("#story-apercu");
  const zoneMedia = el.querySelector(".story-edit__media");
  const info = el.querySelector("#story-info");

  el.querySelector("#story-fonds").addEventListener("click", (e) => {
    const b = e.target.closest("[data-fond]");
    if (!b) return;
    fond = +b.dataset.fond;
    apercuEl.style.background = FONDS[fond];
    el.querySelectorAll("[data-fond]").forEach((x) => x.classList.toggle("est-actif", x === b));
  });

  const charger = async (input, type) => {
    const f = input.files?.[0];
    if (!f) return;
    if (type === "video" && f.size > limiteVideo() * 1024 * 1024)
      return toast(`Vidéo trop lourde (max ${limiteVideo()} Mo)`, "erreur");
    info.textContent = "Préparation…";
    try {
      media = await Store.upload(f, type);
      typeMedia = type;
      zoneMedia.hidden = false;
      zoneMedia.innerHTML =
        type === "video"
          ? `<video src="${esc(media)}" controls playsinline></video>`
          : `<img src="${esc(media)}" alt="">`;
      info.textContent = "";
    } catch (e) {
      info.textContent = "";
      toast(e.message || "Fichier impossible à charger", "erreur");
    }
    input.value = "";
  };
  el.querySelector("#story-image").addEventListener("change", (e) => charger(e.target, "image"));
  el.querySelector("#story-video").addEventListener("change", (e) => charger(e.target, "video"));
}
